export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "AI": "AI",
        "AI provider lub model nie został skonfigurowany": "AI provider or model has not been configured",
        "AI:": "AI:",
        "Anuluj": "Cancel",
        "Asystent AI": "AI Assistant",
        "Bezpośredni": "Direct",
        "Błąd": "Error",
        "Błąd podczas odtwarzania audio.": "Error while playing audio.",
        "Błąd podczas przetwarzania OCR": "Error while processing OCR",
        "Błąd podczas przetwarzania pliku": "Error while processing file",
        "Błąd podczas tworzenia embedding": "Error while creating embedding",
        "Błąd przesyłania pliku:": "File upload error:",
        "Błąd przetwarzania": "Processing error",
        "Błąd przetwarzania DOCX": "DOCX processing error",
        "Błąd przetwarzania PDF": "PDF processing error",
        "Błąd przetwarzania TXT": "TXT processing error",
        "Błąd serwisu AI:": "AI service error:",
        "Błąd TTS": "TTS error",
        "Błąd:": "Error:",
        "Brak danych w formularzu": "No data in form",
        "Brak dostępnych konwersacji.": "No conversations available.",
        "Brak lub nieprawidłowy imageBase64": "Missing or invalid imageBase64",
        "Brak lub nieprawidłowy tekst": "Missing or invalid text",
        "Brak oceny": "No rating",
        "Brak pasujących fragmentów w załączonych dokumentach. Upewnij się, że dodałeś dokumenty do tej sesji.": "No matching fragments in attached documents. Make sure you have added documents to this session.",
        "Brak pliku do przetworzenia": "No file to process",
        "Brak sessionId w zapytaniu": "Missing sessionId in request",
        "Brak tokenu": "Missing token",
        "Brak wiadomości": "No message",
        "Brak wymaganych parametrów: fileId i sessionId": "Missing required parameters: fileId and sessionId",
        "Brak wymaganych parametrów: query i sessionId": "Missing required parameters: query and sessionId",
        "Chat": "Chat",
        "Chat AI": "AI Chat",
        "Content-Type musi być multipart/form-data": "Content-Type must be multipart/form-data",
        "Czat z dokumentami": "Chat with documents",
        "Czat z możliwością dodania i analizy dokumentów": "Chat with option to add and analyze documents",
        "Czat z narzędziami": "Chat with tools",
        "Cześć, jestem Edito Bot. W czym mogę Ci pomóc?": "Hi, I am Edito Bot. How can I help you?",
        "Czy na pewno chcesz usunąć tę konwersację?": "Are you sure you want to delete this conversation?",
        "Czy na pewno chcesz usunąć tę wiadomość?": "Are you sure you want to delete this message?",
        "Czytaj na głos": "Read aloud",
        "Data dodania": "Date added",
        "Data utworzenia": "Creation date",
        "Deployment/model TTS nie istnieje lub nie jest aktywny na Twoim Azure OpenAI.": "TTS deployment/model does not exist or is not active in your Azure OpenAI.",
        "dni temu": "days ago",
        "Dodaj dokumenty": "Add documents",
        "Dodaj obraz": "Add image",
        "Dodaj obrazy": "Add images",
        "Dodaj plik": "Add file",
        "Dokument podzielony na fragmenty - gotowy do użycia": "Document split into fragments - ready to use",
        "Dokument został przetworzony pomyślnie": "Document has been processed successfully",
        "Domyślny": "Default",
        "Dopasowane instrukcje": "Matched instructions",
        "Dziękujemy za podzielenie się opinią": "Thank you for sharing feedback",
        "Edytuj i wyślij ponownie": "Edit and resend",
        "Edytuj wiadomość": "Edit message",
        "Email użytkownika": "User email",
        "Formalny, rzeczowy, neutralny": "Formal, factual, neutral",
        "Formaty:": "Formats:",
        "godz. temu": "hrs ago",
        "Gotowy do użycia": "Ready to use",
        "Jasne, zdecydowane sformułowania, bez wahania": "Clear, decisive wording, without hesitation",
        "Konfiguracja ai": "AI configuration",
        "Konwersacja": "Conversation",
        "Konwersacje": "Conversations",
        "Kopiuj": "Copy",
        "Krótkie, jasne odpowiedzi bez ozdobników": "Short, clear answers without embellishments",
        "Logi odpowiedzi chatu AI": "AI chat answer logs",
        "Luźny, naturalny, codzienny": "Casual, natural, everyday",
        "min temu": "min ago",
        "Model do odpowiedzi": "Answer model",
        "Model embedding": "Embedding model",
        "Model embedding nie istnieje lub nie jest aktywny na Twoim Azure OpenAI.": "Embedding model does not exist or is not active in your Azure OpenAI.",
        "Model OCR": "OCR model",
        "Model OCR nie istnieje lub nie jest aktywny na Twoim Azure OpenAI.": "OCR model does not exist or is not active in your Azure OpenAI.",
        "Model TTS": "TTS model",
        "Monitoring": "Monitoring",
        "Narzędzia AI": "AI tools",
        "Nazwa": "Name",
        "Nazwa konwersacji": "Conversation name",
        "Nazwa użytkownika": "User name",
        "Nie można znaleźć odpowiedniego modelu chat lub dostawcy AI": "Cannot find matching chat model or AI provider",
        "Nie można znaleźć odpowiedniego modelu embedding lub dostawcy AI": "Cannot find matching embedding model or AI provider",
        "Nie można znaleźć odpowiedniego modelu OCR lub dostawcy AI": "Cannot find matching OCR model or AI provider",
        "Nie można znaleźć odpowiedniego modelu TTS lub dostawcy AI": "Cannot find matching TTS model or AI provider",
        "Nie otrzymano treści od asystenta.": "No content received from assistant.",
        "Nie pomocna": "Not helpful",
        "Nie udało się wyodrębnić treści z pliku": "Failed to extract content from file",
        "Nie związana": "Not related",
        "Niedozwolony format pliku. (${file.name})": "File format not allowed. (${file.name})",
        "Nieobsługiwany typ pliku": "Unsupported file type",
        "Nieobsługiwany typ pliku. Obsługiwane formaty: PDF, DOCX, TXT, JPG, PNG": "Unsupported file type. Supported formats: PDF, DOCX, TXT, JPG, PNG",
        "Nieprawidłowe żądanie: Brak sessionId lub message w treści żądania.": "Invalid request: Missing sessionId or message in request body.",
        "Nieznany błąd": "Unknown error",
        "Nowa": "New",
        "Nowa konwersacja": "New conversation",
        "Obraz został przetworzony pomyślnie": "Image has been processed successfully",
        "Ocena": "Rating",
        "Oczekuje na przetworzenie": "Waiting for processing",
        "Odpowiedź oceniona": "Answer rated",
        "Odpowiedź systemu": "System answer",
        "Pewny siebie": "Confident",
        "Plik jest za duży": "File is too large",
        "Plik jest za duży. Maksymalny rozmiar": "File is too large. Maximum size",
        "Plik jest zbyt duży (${formatFileSize(file.size)}). Max: ${maxFileSizeLabel.value}": "File is too large (${formatFileSize(file.size)}). Max: ${maxFileSizeLabel.value}",
        "Plik nie jest obrazem. Obsługiwane formaty: JPG, PNG, GIF, BMP, WebP": "File is not an image. Supported formats: JPG, PNG, GIF, BMP, WebP",
        "Podaj nową nazwę...": "Enter new name...",
        "Podsumowanie tekstu": "Text summary",
        "Podsumuj tekst": "Summarize text",
        "Polecenie początkowe": "Initial prompt",
        "Pomocna": "Helpful",
        "Popraw gramatykę": "Improve grammar",
        "Popraw gramatykę, pisownię i interpunkcję": "Improve grammar, spelling and punctuation",
        "Powrót": "back",
        "Profesjonalny": "Professional",
        "Przeciągnij i upuść plik tutaj lub kliknij, aby wybrać.": "Drag and drop file here or click to select.",
        "Przejdź do konfiguracji, aby włączyć": "Go to configuration to enable",
        "Przetwarzanie...": "Processing...",
        "Przetworzone pytania": "Processed questions",
        "Przyjazny": "Friendly",
        "Pytanie użytkownika": "User question",
        "Repozytorium plików": "File repository",
        "Rozpocznij nową, klikając przycisk poniżej.": "Start a new one by clicking button below.",
        "Rozwijaj tekst": "Expand text",
        "Rozwijanie tekstu": "Text expansion",
        "Skracaj tekst": "Shorten text",
        "Skracanie tekstu": "Text shortening",
        "Swobodny": "Casual",
        "System": "System",
        "Szczegóły odpowiedzi bota": "Bot answer details",
        "Szczegóły wątku": "Thread details",
        "Sztuczna inteligencja": "Artificial intelligence",
        "Ta odpowiedź jest pomocna": "This answer is helpful",
        "Ta odpowiedź jest powiązana": "This answer is related",
        "Ta odpowiedź nie jest pomocna": "This answer is not helpful",
        "teraz": "now",
        "Tłumacz PL - EN": "Translator PL - EN",
        "Tłumacz tekst między PL i EN": "Translate text between PL and EN",
        "tokenów": "tokens",
        "Ton serdeczny, okazujący troskę lub wsparcie": "Warm tone showing care or support",
        "Ty:": "You:",
        "Ustawienia": "Settings",
        "Ustawienia modeli": "Model settings",
        "Ustawienia modeli AI": "AI model settings",
        "Usunięto ${removedCount} fragmentów dokumentu": "Deleted ${removedCount} document fragments",
        "Usuń": "delete",
        "Usuń konwersację": "Delete conversation",
        "Usuń obraz": "Delete image",
        "Usuń plik": "Delete file",
        "Usuń załączony plik": "Delete attached file",
        "Użytkownik": "User",
        "wczoraj": "yesterday",
        "Wewnętrzny błąd serwera": "Internal server error",
        "Wpisz wiadomość...": "Type a message...",
        "Wprowadź treść wiadomości...": "Enter message content...",
        "Wybierz konwersację, aby rozpocząć": "Select conversation to start",
        "Wybierz lub utwórz konwersację": "Select or create conversation",
        "Wybierz model do czatu": "Select chat model",
        "Wybierz model embedding": "Select embedding model",
        "Wybierz model OCR": "Select OCR model",
        "Wybierz model TTS": "Select TTS model",
        "Wybierz plik": "Select file",
        "Wybróbuj możliwości chatu AI": "Try AI chat capabilities",
        "Wystąpił błąd podczas przesyłania pliku.": "An error occurred while uploading file.",
        "Wystąpił błąd podczas usuwania dokumentu.": "An error occurred while deleting document.",
        "Wystąpił błąd podczas usuwania obrazu.": "An error occurred while deleting image.",
        "Wystąpił błąd podczas wyszukiwania w dokumentach. Spróbuj ponownie.": "An error occurred while searching documents. Please try again.",
        "Wystąpił błąd serwera podczas streamingu. Spróbuj ponownie później.": "A server error occurred during streaming. Please try again later.",
        "Wystąpił nieoczekiwany błąd.": "An unexpected error occurred.",
        "Wystąpił problem z pobraniem wiadomości.": "There was a problem retrieving messages.",
        "Wyślij ponownie": "Resend",
        "Wyślij wiadomość": "Send message",
        "Zadaj pytanie": "Ask a question",
        "Załączone dokumenty:": "Attached documents:",
        "Załączone obrazy:": "Attached images:",
        "Załączone pliki": "Attached files",
        "Zamknij": "Close",
        "Zapisz": "Save",
        "Zapisz i wyślij ponownie": "Save and resend",
        "Zatrzymaj": "Stop",
        "Zmień nazwę": "Rename",
        "Zmień nazwę konwersacji": "Rename conversation",
        "Zmień ton": "Change tone",
        "Zmień ton tekstu": "Change text tone"
    }
};
